import DZModelMenu from "@/views/系统管理/model/DZModelMenu";

/**
 * 角色
 */
class DZModelRole{

    /**
     * 主键
     */
    id = "";

    /**
     * 角色名称
     */
    name = "";

    /**
     * 状态标记：0-正常，1-停用
     */
    status = 0;

    /**
     * 角色菜单列表
     */
    menusList = [];

    disabled = false
}
export default DZModelRole;
